import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [needsVerification, setNeedsVerification] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setNeedsVerification(false);
    setLoading(true);

    try {
      const response = await authAPI.login(formData);
      
      // Login with token only - user data will be fetched from server
      const userData = await login(response.data.token);
      
      // Check if account is pending approval
      if (userData.role === 'user' && !userData.isApproved) {
        navigate('/pending-approval');
        return;
      }
      
      if (userData.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/user');
      }
    } catch (err) {
      // Check if error is due to email verification
      if (err.response?.data?.needsVerification) {
        setError(err.response.data.message);
        setNeedsVerification(true);
      } else if (err.response?.data?.isPending) {
        setError(err.response.data.message);
      } else {
        setError(err.response?.data?.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '440px', margin: '40px auto' }}>
        <h2 style={{ marginBottom: '8px', textAlign: 'center', color: '#667eea', fontSize: '22px', fontWeight: '700' }}>
          Welcome Back
        </h2>
        <p style={{ textAlign: 'center', color: '#718096', fontSize: '13px', marginBottom: '24px' }}>
          Sign in to your account to continue
        </p>
        {error && (
          <div className="error">
            {error}
            {needsVerification && (
              <div style={{ marginTop: '12px' }}>
                <Link 
                  to="/verify-email/resend" 
                  state={{ email: formData.email }}
                  style={{ 
                    color: '#667eea', 
                    fontWeight: '600',
                    textDecoration: 'underline'
                  }}
                >
                  Resend verification email
                </Link>
              </div>
            )}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                style={{ paddingRight: '45px' }}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '18px',
                  color: '#718096',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            <div style={{ textAlign: 'right', marginTop: '8px' }}>
              <Link 
                to="/forgot-password" 
                style={{ 
                  color: '#667eea', 
                  fontSize: '12px', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                Forgot Password?
              </Link>
            </div>
          </div>
          <button 
            type="submit" 
            className="btn btn-primary" 
            style={{ width: '100%', marginTop: '8px', padding: '12px' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: '#4a5568' }}>
          <Link to="/enquiry" style={{ color: '#667eea', fontWeight: '600', textDecoration: 'none' }}>
            Submit a course enquiry
          </Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: '12px', fontSize: '13px', color: '#4a5568' }}>
          Don't have an account? <Link to="/register" style={{ color: '#667eea', fontWeight: '600', textDecoration: 'none' }}>Create Account</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
